import { render, staticRenderFns } from "./organizatie.vue?vue&type=template&id=273de812&"
import script from "./organizatie.vue?vue&type=script&lang=js&"
export * from "./organizatie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports